import { UserContext } from "contexts/UserContext"
import { useContext, useEffect } from "react"
import { useRoutes } from "react-router-dom"
import routes from "./routes"

export default function Routes() {
	const { isAuth, getDataUser } = useContext(UserContext)

	const routing = useRoutes(routes(isAuth))
	return <>{routing}</>
}
